module.exports = __webpack_public_path__ + "img/VXlogo.9e42fa3f.png";